import * as React from "react";
const SvgMinusXsmall = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}><path fill="currentColor" d="M9.5 5.5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" /></svg>;
export default SvgMinusXsmall;